import React from 'react';
import { Navigate } from 'react-router-dom';

import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';
import freelancerRoutes from 'pages/freelancer/FreelancerSignUpPage/freelancer-routes';

type FreelancerRouteProps = {
  children: unknown;
  requireAuth?: boolean;
};

const FreelancerRoute = (props: FreelancerRouteProps): JSX.Element => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  if (props.requireAuth && !isLoggedIn) {
    return <Navigate to={freelancerRoutes.landing.path} replace />;
  }

  if (!props.requireAuth && isLoggedIn) {
    return <Navigate to={freelancerRoutes.fillInformation.path} replace />;
  }

  return <>{props.children}</>;
};

export default FreelancerRoute;
